import React from "react"
import ReactDOM from "react-dom"

import * as Sentry from "@sentry/browser"

import { App } from "./App"
import { getSentryConfig } from "./config/sentry"

Sentry.init(getSentryConfig())

ReactDOM.render(<App />, document.getElementById("root"))

// So some rules applies in CSS for iPhone keyboard
if (/iPod|iPhone|iPad/i.test(navigator.userAgent)) {
  document.body.classList.add("ios")
}
